/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const variantData = {
    primary: {
        color: 'on-primary',
        fontSize: { large: undefined, small: undefined },
        textCase: 'uppercase',
        weight: 'medium',
        fontFamily: 'headline',
    },
    secondary: {
        color: 'on-secondary',
        fontSize: { large: undefined, small: undefined },
        textCase: 'uppercase',
        weight: 'medium',
        fontFamily: 'headline',
    },
    tertiary: {
        color: 'on-secondary',
        fontSize: { large: undefined, small: undefined },
        textCase: 'uppercase',
        weight: 'medium',
        fontFamily: 'headline',
    },
    super: {
        color: 'on-primary',
        fontSize: {
            small: '125',
            large: '150',
        },
        textCase: 'uppercase',
        weight: 'heavy',
        fontFamily: 'headline',
    },
    ghost: {
        color: 'on-secondary',
        fontSize: { large: undefined, small: undefined },
        textCase: 'uppercase',
        weight: 'medium',
        fontFamily: 'headline',
    },
    chevron: {
        color: 'on-secondary',
        fontSize: { large: undefined, small: undefined },
        textCase: 'uppercase',
        weight: 'medium',
        fontFamily: 'headline',
    },
    pill: {
        color: 'on-primary',
        fontSize: { small: undefined, large: undefined },
        textCase: undefined,
        weight: 'bold',
        fontFamily: 'body',
    },
    icon: {
        color: 'on-primary',
        fontSize: { large: undefined, small: undefined },
        textCase: undefined,
        weight: undefined,
        fontFamily: 'body',
    },
    disabled: {
        color: 'on-disabled',
        fontSize: { large: undefined, small: undefined },
        textCase: 'uppercase',
        weight: 'medium',
        fontFamily: 'body',
    },
    'pill-secondary': {
        color: 'on-secondary',
        fontSize: { small: undefined, large: undefined },
        textCase: undefined,
        weight: 'bold',
        fontFamily: 'body',
    },
    'stacked-icon': {
        color: 'gray-500',
        fontSize: {
            small: '075',
            large: '087',
        },
        textCase: undefined,
        weight: 'bold',
        fontFamily: 'body',
    },
};
